import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { WarningAmber } from '@mui/icons-material';

const DeleteDialogMessage = ({ description }) => (
  <Stack spacing={1.5} sx={{ pt: 0.5 }}>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1.25,
        p: 1.5,
        borderRadius: 2,
        bgcolor: 'rgba(211, 47, 47, 0.08)',
        border: '1px solid rgba(211, 47, 47, 0.18)',
      }}
    >
      <WarningAmber color="error" fontSize="small" sx={{ mt: '2px' }} />
      <Box>
        <Typography variant="subtitle2" sx={{ fontWeight: 800, color: 'error.main', mb: 0.5 }}>
          Atenção
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.primary' }}>
          {description}
        </Typography>
      </Box>
    </Box>
    <Typography variant="body2" sx={{ fontWeight: 700, color: 'error.main' }}>
      Esta ação é irreversível.
    </Typography>
  </Stack>
);

export const buildDeleteDialogMessage = (description) => (
  <DeleteDialogMessage description={description} />
);

export default DeleteDialogMessage;
